import "./App.css";
import Navbar from "./Navbar";

import PlayProvider from "./Play";

import { BrowserRouter, Routes, Route } from "react-router-dom";
import Rollete from "./Rolette";
import { useState } from "react";
import Footer from "./Footer";

function App() {
  const [, rerender] = useState();
  return (
    <div className="App">
      <Navbar onChange={rerender}></Navbar>

      <PlayProvider>
        <Routes>
          <Route exact path="/" element={<Rollete></Rollete>}></Route>
        </Routes>
      </PlayProvider>

      <Footer></Footer>
    </div>
  );
}

export default App;
